import React, { useEffect } from 'react';
import { getProductEntityName } from '../Product.config';
import { useAssignUserNeedVerification } from '../Product.hooks';

import {
  ProductVerification,
  BaseProductAssignDialogProps
} from '../Product.interface';
import AssignVerificationDialog from './AssignVerificationDialog';

export type UserNeedAssignVerificationDialogProps =
  BaseProductAssignDialogProps<'userNeedId'>;

const UserNeedAssignVerificationDialog: React.FC<UserNeedAssignVerificationDialogProps> =
  (props: UserNeedAssignVerificationDialogProps) => {
    const {
      open,
      productId,
      userNeedId,
      selectedItems,
      onCancel,
      onError,
      onAssigned
    } = props;
    const {
      updatedProductUserNeed,
      isAssigning,
      error: assignError,
      assignVerifications
    } = useAssignUserNeedVerification(productId, userNeedId);

    useEffect(() => {
      if (updatedProductUserNeed) {
        onAssigned?.(updatedProductUserNeed);
      }
    }, [updatedProductUserNeed]);

    useEffect(() => {
      if (assignError) {
        onError?.(assignError);
      }
    }, [assignError]);

    return (
      <AssignVerificationDialog
        {...{ open, productId, selectedItems, onCancel, onError }}
        isLoading={isAssigning}
        contentText={`Search for Verifications to assign to the ${getProductEntityName(
          'userNeed'
        )}.`}
        onSubmit={(verifications: ProductVerification[]) => {
          assignVerifications({
            verificationIds: verifications.map(
              (verification: ProductVerification) => verification.id
            )
          });
        }}
      />
    );
  };

export default UserNeedAssignVerificationDialog;
